"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewStore = void 0;
var view_1 = require("./view");
Object.defineProperty(exports, "viewStore", { enumerable: true, get: function () { return view_1.viewStore; } });
//# sourceMappingURL=index.js.map